import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useWaterproofKitsApi } from "../../../../../http/border/useWaterproofKits";
import WaterproofKitForm from "./WaterproofKitForm";

interface EditWaterproofKitProps {
  onClose: () => void;
  waterproofKitId: string;
}

const EditWaterproofKit: FC<EditWaterproofKitProps> = ({ onClose, waterproofKitId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const waterproofKitApi = useWaterproofKitsApi();

  const { data, error, trigger } = waterproofKitApi.getAdminWaterproofKit(waterproofKitId, aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    waterproofKitId && trigger();
  }, [waterproofKitId]);

  return (
    <WaterproofKitForm
      onClose={onClose}
      waterproofKit={data}
      isDisabled={!!error}
      isLoading={!data && !error}
    />
  );
};

export default EditWaterproofKit;
